<template>
    <div>
        <div class="d-md-none">
            <div v-if="upperCarouselBanners.length" class="topicBanners topicBanners--fullWidth">
                <div :id="`js-slim-carousel-${carouselId + 1}`" ref="carousel1" class="slim-carousel">
                    <a
                        v-if="upperCarouselBanners.length > 4"
                        href="#"
                        class="slim-carousel__control slim-carousel__control--left js-slime-carousel-left d-none"
                        :aria-label="$t('slides.previous')"
                    >
                        <img :src="`/nuxt-assets/icons/arrow-black.svg`" alt="arrow" width="11" height="20" />
                    </a>
                    <a
                        v-if="upperCarouselBanners.length > 4"
                        href="#"
                        class="slim-carousel__control slim-carousel__control--right js-slime-carousel-right"
                        :aria-label="$t('slides.next')"
                    >
                        <img :src="`/nuxt-assets/icons/arrow-black.svg`" alt="arrow" width="11" height="20" />
                    </a>
                    <div class="slim-carousel__container js-slim-carousel-scroll-container mb-0">
                        <div
                            v-for="(upperCarouselBanner, index) in upperCarouselBanners"
                            :key="index"
                            class="slim-carousel__item slim-carousel__item--upper-carousel-banners"
                            :data-id="upperCarouselBanner.id"
                            :data-title="upperCarouselBanner.title"
                        >
                            <div class="banner" :class="resolveColorVariantCssVariant(upperCarouselBanner)">
                                <a :href="upperCarouselBanner.url">
                                    <div v-if="upperCarouselBanner.mediaType === 'video' || upperCarouselBanner.image.endsWith('.mp4')">
                                        <video class="banner__video" autoplay muted loop playsinline>
                                            <source :src="upperCarouselBanner.image" type="video/mp4" />
                                        </video>
                                    </div>
                                    <img v-else :src="upperCarouselBanner.image" />
                                    <div class="banner__container">
                                        <div class="banner__container__inner">
                                            <h2>{{ upperCarouselBanner.title }}</h2>
                                            <p v-if="upperCarouselBanner.description">{{ upperCarouselBanner.description }}</p>
                                            <button v-if="upperCarouselBanner.ctaText">{{ upperCarouselBanner.ctaText }}</button>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="upperBanners.length" class="topicBanners topicBanners--fullWidth">
            <div :id="`js-slim-carousel-${carouselId}`" ref="carousel2" class="slim-carousel">
                <a
                    v-if="upperBanners.length > 4"
                    href="#"
                    class="slim-carousel__control slim-carousel__control--left js-slime-carousel-left d-none"
                    :aria-label="$t('slides.previous')"
                >
                    <img :src="`/nuxt-assets/icons/arrow-black.svg`" alt="arrow" width="11" height="20" />
                </a>
                <a
                    v-if="upperBanners.length > 4"
                    href="#"
                    class="slim-carousel__control slim-carousel__control--right js-slime-carousel-right"
                    :aria-label="$t('slides.next')"
                >
                    <img :src="`/nuxt-assets/icons/arrow-black.svg`" alt="arrow" width="11" height="20" />
                </a>
                <div class="slim-carousel__container js-slim-carousel-scroll-container">
                    <div
                        v-for="(banner, bannerIndex) in upperCarouselBanners"
                        v-show="bannerIndex === currentBannerIndex"
                        :key="`carousel-${bannerIndex}`"
                        class="slim-carousel__item slim-carousel__item--banners slim-carousel__item--desktop-only"
                    >
                        <div class="banner" :class="resolveColorVariantCssVariant(banner)">
                            <a :href="banner.url">
                                <div v-if="banner.mediaType === 'video' || banner.image.endsWith('.mp4')">
                                    <video class="banner__video" autoplay muted loop playsinline>
                                        <source :src="banner.image" type="video/mp4" />
                                    </video>
                                </div>
                                <img v-else :src="banner.image" />
                                <div class="banner__container">
                                    <div class="banner__container__inner">
                                        <h2>{{ banner.title }}</h2>
                                        <p v-if="banner.description">{{ banner.description }}</p>
                                        <button v-if="banner.ctaText">{{ banner.ctaText }}</button>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div
                        v-for="(upperBanner, index) in upperBanners"
                        :key="index"
                        class="slim-carousel__item slim-carousel__item--banners"
                        :data-id="upperBanner.id"
                        :data-title="upperBanner.title"
                    >
                        <div class="banner" :class="resolveColorVariantCssVariant(upperBanner)">
                            <a :href="upperBanner.url">
                                <div v-if="upperBanner.mediaType === 'video' || upperBanner.image.endsWith('.mp4')">
                                    <video class="banner__video" autoplay muted loop playsinline>
                                        <source :src="upperBanner.image" type="video/mp4" />
                                    </video>
                                </div>
                                <img v-else :src="upperBanner.image" />

                                <div class="banner__container">
                                    <div class="banner__container__inner">
                                        <h2>{{ upperBanner.title }}</h2>
                                        <p v-if="upperBanner.description">{{ upperBanner.description }}</p>
                                        <button v-if="upperBanner.ctaText">{{ upperBanner.ctaText }}</button>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUpdated, onBeforeUnmount } from 'vue'
import SlimCarousel from '~/mixins/SlimCarousel'
import Banner from '~/models/components/Banner'

let id = 200

const props = defineProps<{
    upperCarouselBanners: Banner[]
    upperBanners: Banner[]
}>()

id++
const carousel1 = ref<HTMLElement | null>(null)
const carousel2 = ref<HTMLElement | null>(null)
const carouselId = ref<number>(id)
const loading = ref(true)
const currentBannerIndex = ref(0)
let bannerInterval: NodeJS.Timeout | null = null

useHead(() => {
    const link: Array<{ rel: string; href: string; as: 'image' }> = []

    props.upperBanners.forEach((banner: Banner, index: number) => {
        if (index < 4) {
            link.push({
                rel: 'preload',
                href: banner.image,
                as: 'image' as const,
            })
        }
    })

    return { link }
})

const resolveColorVariantCssVariant = (banner: Banner): string => {
    if (banner.colorVariant === 'white') {
        return 'banner--white'
    }
    if (banner.colorVariant === 'dark') {
        return 'banner--dark'
    }

    return 'banner--brand'
}

onUpdated(() => {
    if (carousel1.value) {
        new SlimCarousel({ el: carousel1.value.id })
    }
    if (carousel2.value) {
        new SlimCarousel({ el: carousel2.value.id })
    }
})

onMounted(() => {
    loading.value = false
    if (carousel1.value) {
        new SlimCarousel({ el: carousel1.value.id })
    }
    if (carousel2.value) {
        new SlimCarousel({ el: carousel2.value.id })
    }

    if (props.upperCarouselBanners.length > 1) {
        bannerInterval = setInterval(() => {
            currentBannerIndex.value = (currentBannerIndex.value + 1) % props.upperCarouselBanners.length
        }, 10000)
    }
})

onBeforeUnmount(() => {
    if (bannerInterval) {
        clearInterval(bannerInterval)
    }
})
</script>

<style lang="scss" scoped>
.topicBanners {
    width: 100%;
    margin: 0 auto;

    &--fullWidth {
        //margin-top: 10px;
        width: calc(100% + 2 * $padding-container-inside-mobile);
        margin-left: -$padding-container-inside-mobile;

        @media (min-width: 576px) {
            width: calc(100% + 40px);
            max-width: calc($max-width-container-inside + 40px);
            margin-left: -20px;
        }

        @media (min-width: $max-width-container-inside) {
            margin-left: 0;
            margin-right: 0;
            width: 100%;
            max-width: 1600px;
        }
    }
}

.slim-carousel {
    position: relative;

    @media (min-width: 480px) {
        margin-bottom: 1rem;
    }
}

.slim-carousel__container {
    display: flex;
    padding: 15px 15px 0;
    height: auto;
    overflow-x: auto;
    width: 100%;
    gap: 8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-bottom: 10px;

    @media (min-width: 576px) {
        padding: 15px 20px;
    }

    @media (min-width: $max-width-container-inside) {
        padding: 15px 1px;
        margin-top: 10px;
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 10px;
    }

    &:hover::-webkit-scrollbar-thumb {
        border: 0;
        background-color: $color-grey-semi-dark;
        border-radius: 10px;
        cursor: pointer;

        @media (min-width: 890px) {
            display: none;
        }
    }
}

.slim-carousel__control {
    display: none;
    padding-left: 3px;

    @media (min-width: 890px) {
        position: absolute;
        top: calc(50% - 42px);
        width: 33px;
        height: 33px;
        border-radius: 33px;
        transition: all 0.3s;
        z-index: 5;
        background-color: $color-white;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $color-secondary-dark-green-2;
    }

    &--left {
        @media (min-width: 890px) {
            left: 0;
            transform: rotate(180deg);
        }
        @media (min-width: $max-width-container-inside) {
            left: -16px;
        }
    }

    &--right {
        @media (min-width: 890px) {
            right: 0;
        }
        @media (min-width: $max-width-container-inside) {
            right: -16px;
        }
    }

    &:deep(svg) {
        margin-left: 2px;
        fill: $color-white;
    }
}

$maxBannerHeight: 390px;
$maxBannerHeightDesktop: 440px;
.slim-carousel__item--banners {
    display: flex;
    max-height: $maxBannerHeight;
    height: auto;
    width: auto;
    flex-shrink: 0;

    img,
    .banner__video {
        max-height: $maxBannerHeight;
    }

    @include screen-md {
        max-height: $maxBannerHeightDesktop;

        img,
        .banner__video {
            max-height: $maxBannerHeightDesktop;
        }
    }
}

.slim-carousel__item--upper-carousel-banners {
    display: flex;
    flex: 0 0 calc(100% / 1);
    min-width: 180px;
}

.slim-carousel__item--desktop-only {
    display: none;

    @include screen-md {
        display: flex;
    }
}

.banner {
    width: 100%;
    position: relative;

    img {
        border-radius: 16px;
    }

    &__video {
        border-radius: 16px;
    }

    &__container {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: end;
        align-items: start;
        container-type: size;

        &__inner {
            display: flex;
            flex-direction: column;
            align-items: start;
            gap: 4px;
            padding: 0 10px 15px;
            max-width: 70%;

            // small on mobile
            @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 0px) {
                padding: 0 10px 15px;
                max-width: 100%;
            }

            // big on mobile
            @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 350px) {
                padding: 0 20px 20px;
                max-width: 70%;
            }

            // small on desktop
            @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 210px) {
                padding: 0 20px 20px;
                max-width: 100%;
                gap: 6px;
            }

            // big on desktop
            @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 400px) {
                padding: 0 30px 30px;
                max-width: 55%;
                gap: 10px;
            }
        }
    }

    h2 {
        color: $color-white;
        margin: 0 0 0;
        font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
            'Droid Sans', 'Helvetica Neue', sans-serif;
        font-variation-settings: 'wght' 500, 'wdth' 125;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 2px;

        // small on mobile
        @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 0px) {
            font-size: 13px;
            line-height: 16px;
        }

        // big on mobile
        @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 200px) {
            font-size: 19px;
            line-height: 25px;
        }

        // small on desktop
        @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 210px) {
            font-size: 22px;
            line-height: 29px;
        }

        // big on desktop
        @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 400px) {
            font-size: 22px;
            line-height: 29px;
            font-variation-settings: 'wght' 500, 'wdth' 135;
        }
    }

    p {
        color: $color-white;
        margin: 0;
        font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
            'Droid Sans', 'Helvetica Neue', sans-serif;
        font-variation-settings: 'wght' 300, 'wdth' 100;
        font-size: 13px;
        line-height: 15px;

        // small on mobile
        @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 0px) {
            font-size: 13px;
            line-height: 15px;
        }

        // big on mobile
        @container (min-height: #{$maxBannerHeight - 10px}) and (min-width: 200px) {
            font-size: 14px;
            line-height: 19px;
        }

        // small on desktop
        @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 210px) {
            font-size: 17px;
            line-height: 23px;
        }

        // big on desktop
        @container (min-height: #{$maxBannerHeightDesktop - 10px}) and (min-width: 400px) {
            font-size: 17px;
            line-height: 23px;
        }
    }

    button {
        background: $color-secondary-dark-green-1;
        color: $color-secondary-accent-green;
        border-radius: 35px;
        padding: 4px 8px;
        font-weight: 500;
        font-size: 13px;
        margin-top: 0;
        cursor: pointer;

        @include screen-md {
            font-size: 16px;
            padding: 8px 16px;
        }
    }

    &--white {
        button {
            background: $color-white;
            color: $color-secondary-dark-green-1;
        }
    }

    &--dark {
        h2 {
            color: #004840;
        }

        button {
            background: $color-secondary-dark-green-1;
            color: $color-secondary-accent-green;
        }

        p {
            color: #004840;
        }
    }

    &--brand {
        h2 {
            color: $color-primary-pink;
        }

        p {
            color: $color-white;
        }

        button {
            background: $color-primary-pink;
            color: $color-primary-green;
        }
    }

    &:hover {
        button {
            background: $color-secondary-accent-green;
            color: $color-primary-green;
        }
    }
}
</style>
